module.exports = __webpack_public_path__ + "static/img/Aandroid.93f379b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/Aandroid.png
// module id = eONI
// module chunks = 1